/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Manage_Rename_HelperInputs */

const en_us2_coach_manage_rename_helper = /** @type {(inputs: Coach_Manage_Rename_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replaces the name taken from your first message.`)
};

const pt_br2_coach_manage_rename_helper = /** @type {(inputs: Coach_Manage_Rename_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fica no lugar do nome tirado da sua primeira mensagem.`)
};

const es_419_coach_manage_rename_helper = /** @type {(inputs: Coach_Manage_Rename_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reemplaza el nombre tomado de tu primer mensaje.`)
};

const pt_pt2_coach_manage_rename_helper = /** @type {(inputs: Coach_Manage_Rename_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Substitui o nome tirado da tua primeira mensagem.`)
};

const fr_fr2_coach_manage_rename_helper = /** @type {(inputs: Coach_Manage_Rename_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplace le nom tiré de ton premier message.`)
};

const de_de2_coach_manage_rename_helper = /** @type {(inputs: Coach_Manage_Rename_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ersetzt den Namen aus deiner ersten Nachricht.`)
};

const it_it2_coach_manage_rename_helper = /** @type {(inputs: Coach_Manage_Rename_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sostituisce il nome preso dal tuo primo messaggio.`)
};

/**
* | output |
* | --- |
* | "Replaces the name taken from your first message." |
*
* @param {Coach_Manage_Rename_HelperInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_manage_rename_helper = /** @type {((inputs?: Coach_Manage_Rename_HelperInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Manage_Rename_HelperInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_manage_rename_helper(inputs)
	if (locale === "es-419") return es_419_coach_manage_rename_helper(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_manage_rename_helper(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_manage_rename_helper(inputs)
	if (locale === "de-DE") return de_de2_coach_manage_rename_helper(inputs)
	if (locale === "it-IT") return it_it2_coach_manage_rename_helper(inputs)
	return en_us2_coach_manage_rename_helper(inputs)
});
export { coach_manage_rename_helper as "coach-manage.rename_helper" }